import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import I18n from '@module/i18n';
import tcModel from '@module/consent-manager/tc-model';

import { initPurposeListState } from './helper';
import { PurposeDescription } from './descriptions';
import { Consent } from './consent';
import { ConnectedCustomPurposes } from './custom-purposes';

export function PurposeList({ consentLanguage }) {
  const [preferences, setPreferences] = useState(
    initPurposeListState(consentLanguage)
  );

  useEffect(() => {
    setPreferences(initPurposeListState(consentLanguage));
  }, [consentLanguage]);

  const handlePurposeConsent = (id, checked) => {
    const newPref = { ...preferences };
    newPref[id].purposeConsent = checked;
    setPreferences(newPref);

    if (checked) {
      tcModel.purposeConsents.set(id);
      return;
    }

    tcModel.purposeConsents.unset(id);
  };

  const handleLegitimateInterest = (id, checked) => {
    const newPref = { ...preferences };
    newPref[id].purposeLegitimateInterest = checked;
    setPreferences(newPref);

    if (checked) {
      tcModel.purposeLegitimateInterests.set(id);
      return;
    }

    tcModel.purposeLegitimateInterests.unset(id);
  };

  const toggleDescription = (id) => {
    const newPref = { ...preferences };
    newPref[id].descriptionVisible = !newPref[id].descriptionVisible;
    setPreferences(newPref);
  };

  return (
    <>
      {Object.values(preferences).map(
        ({
          id,
          name,
          descriptionVisible,
          purposeLegitimateInterest,
          purposeConsentVisible,
          purposeConsent,
          descriptionLegal,
        }) => (
          <Consent
            key={id}
            onToggle={() => toggleDescription(id)}
            consentName={name}
            className="consent consent--white"
            descriptionVisible={descriptionVisible}
            consentSwitchesProps={[
              {
                name: `legitimate-${id}`,
                label: I18n.t('transfer.consent-manager.switch-by-we-transfer'),
                onChange: (checked) => handleLegitimateInterest(id, checked),
                checked: purposeLegitimateInterest,
              },
              {
                name: `purpose-${id}`,
                disabled: !purposeConsentVisible,
                label: I18n.t('transfer.consent-manager.switch-by-partners'),
                onChange: (checked) => handlePurposeConsent(id, checked),
                checked: purposeConsent,
              },
            ]}
          >
            <PurposeDescription description={descriptionLegal} />
          </Consent>
        )
      )}
      <ConnectedCustomPurposes />
    </>
  );
}

PurposeList.propTypes = {
  consentLanguage: PropTypes.object,
};
